/// <amd-module name="Artifacts/Npm/redux/Module" />

import { rootSaga } from "Artifacts/Npm/redux/Sagas";
import { PackageModule } from "Artifacts/Package/redux";
import { ISagaModule } from "redux-dynamic-modules-saga";

const _npmProtocolModule: ISagaModule<Record<string, never>> = {
  id: "npm-protocol-module",
  reducerMap: {},
  sagas: [rootSaga],
};

export const NpmProtocolModule = [PackageModule, _npmProtocolModule];
